import React from 'react';
import ProjectDashboard from '../components/ProjectDashboard';
import Pageheader from '../utils/headerHelment';
import { toast } from 'react-toastify';
import { isMobile, isTablet } from 'react-device-detect';
import DoubleConfirmationModal from '../components/CommonComponents/DoubleConfirmationModal/DoubleConfirmationModal';
import { setProjectImg } from '../redux/projectDataSlice';
import Cookies from 'js-cookie';
import { setDocs } from '../redux/documentsSlice';
import { logoutWithAudit } from '../redux/usersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { ReactInternetSpeedMeter } from 'react-internet-meter';
const ProjectPage = () => {
    const triggerWarnModalRef = React.useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const memberships = useSelector(state => state?.user?.memberships || []);
    const activeWorkspaceId = useSelector(state => state?.user?.activeWorkspaceId);
    const mobileDeviceWarn = localStorage?.getItem('mobileDeviceWarn');

    console.log({ mobileDeviceWarn });
    React.useEffect(() => {
        if (isMobile || isTablet) {
            if (!mobileDeviceWarn) {
                if (triggerWarnModalRef?.current) {
                    console.log(triggerWarnModalRef?.current?.click());
                }
            }
        }
    }, [triggerWarnModalRef, mobileDeviceWarn]);

    React.useEffect(() => {
        // If user has multiple workspaces and hasn't selected one yet, force selection before loading projects.
        if (memberships.length > 1 && !activeWorkspaceId) {
            navigate('/select-workspace', { replace: true });
        }
    }, [memberships, activeWorkspaceId, navigate]);

    const handleLogout = async () => {
        localStorage.removeItem('persist:root');
        // Clear project dashboard filters/preferences when user logs out
        localStorage.removeItem('projectDashboardFilters');
        Cookies.set('refresh', '');
        dispatch(setProjectImg(''));
        dispatch(setDocs([]));
        await dispatch(logoutWithAudit());
        navigate('/');
    };
    return (
        <>
            <Pageheader title="LENS - Dashboard" />
            {/* <Project /> */}
            <ProjectDashboard />
            <DoubleConfirmationModal
                handleAction={() => localStorage.setItem('mobileDeviceWarn', true)}
                modalOneBtnL="Continue"
                modalOneBtnR="Logout"
                modalTwoBtnR="Continue"
                firstModalActionBtn={handleLogout}
                message={
                    'Please note that Lens is best experienced on a desktop browser. Using a mobile or tablet may significantly impact functionality and your user experience.'
                }>
                <span ref={triggerWarnModalRef}></span>
            </DoubleConfirmationModal>
            <ReactInternetSpeedMeter
                txtSubHeading=""
                outputType="alert"
                customClassName={null}
                txtMainHeading=""
                pingInterval={60000} // milliseconds
                thresholdUnit="megabyte" // "byte" , "kilobyte", "megabyte"
                threshold={100}
                imageUrl="https://beyond-ma.com/wp-content/uploads/2023/07/Lens_Logo.png"
                downloadSize="1781287" //bytes
                callbackFunctionOnNetworkTest={speed => {
                    if (parseFloat(speed) <= 6.5) {
                        toast.warn('Internet speed is slow, it may impact the perfomance of application', {
                            position: 'top-right',
                            autoClose: 5000,
                        });
                    }
                }}
            />
        </>
    );
};

export default ProjectPage;
